import { RELAY_API_CONTENTFUL } from "@/utils/constant";

import {
    PricingPageRelayQuery,
    getPricingPageRelayQueryVars
} from "../contentful/graphql";
import { init as initRelay } from "../init-relay";
import { getPricingTitleInternal } from "../pages/software/jira/service-management/pricing/feature-gates";
import { JiraServiceManagementPricingPage } from "../pages/software/jira/service-management/pricing/jira-service-management-pricing-page";

const pricingTitleInternal = getPricingTitleInternal();

initRelay(
    JiraServiceManagementPricingPage,
    PricingPageRelayQuery,
    getPricingPageRelayQueryVars(
        "jira-service-management",
        window.location,
        pricingTitleInternal
    ),
    RELAY_API_CONTENTFUL
);
